export const DEFAULT_PAGE = 1;
export const DEFAULT_TOTAL = 0;
export const PER_PAGE = 15;

export const PAGE_QUERY_KEY = 'page';
export const FILTER_QUERY_KEYS = [
  'channel',
  'service_code',
  'service_status_name',
  'created_at_from',
  'created_at_to',
] as const;
